import { QSetStatusTag } from '@exam-management/components';
import { EllipsisText, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { MoreActionMenu } from '../more-action-menu';

import { type DisabledQSetRow } from './types';

const columns: GridColDef<DisabledQSetRow>[] = [
  {
    field: 'code',
    headerName: 'QSet ID',
    sortable: false,
    minWidth: 112,
    flex: 1,
    renderCell: (params) => {
      return <EllipsisText>{params.row.code}</EllipsisText>;
    },
  },
  {
    field: 'qConfig.name',
    headerName: 'QConfig Name',
    sortable: false,
    flex: 1,
    minWidth: 240,
    renderCell: (params) => {
      return <EllipsisText>{params.row.qConfig.name}</EllipsisText>;
    },
  },
  {
    field: 'qConfig.code',
    headerName: 'QConfig ID',
    sortable: false,
    width: 120,
    renderCell: (params) => {
      return <EllipsisText>{params.row.qConfig.code}</EllipsisText>;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: false,
    width: 160,
    renderCell: (params) => {
      return <QSetStatusTag status={params.row.status} size='large' />;
    },
  },
  {
    field: 'disabledAt',
    headerName: 'Disabled at',
    width: 180,
    renderCell: (params) => {
      return <>{formatDateTime(params.value)}</>;
    },
  },
  {
    field: 'moreAction',
    headerName: '',
    width: 48,
    sortable: false,
    renderCell: (params) => <MoreActionMenu qSetId={params.row.id} status={params.row.status} />,
  },
];

export default columns;
